import { signedFetch } from '../../services/api';

/**
 * Ask whether to auto-show the Amberwood splash, recording the viewing if so. The
 * backend keeps this in Firestore per CEA — the native WebView drops localStorage —
 * and answers true at most twice in any 24h, at least 6h apart.
 *
 * Any failure reads as "don't show": a splash on every launch whenever the backend
 * is unreachable is worse than missing it once.
 */
export async function claimAmberwoodSplash(): Promise<boolean> {
  try {
    // redirectOnAuthError: false — a campaign splash must never bounce the agent to /unauthorized.
    const response = await signedFetch('/api/super-picker/splash/amberwood/claim', { method: 'POST' }, true, false);
    if (!response.ok) return false;
    const body = await response.json();
    return body?.show === true;
  } catch (error) {
    console.error('Failed to claim Amberwood splash view:', error);
    return false;
  }
}
